import * as React from "react";
import * as UnlinkedApplicationForm from "../../../../components/UnlinkedApplicationForm";
import AppBody from "../../../../components/AppBody";
import Header from "../../../../components/Header";
import { VehiclesListing } from "../../../../features/unlinked-application/components";
export default function UnlinkedApplicationAutoVehicles() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement(VehiclesListing, null)))));
}
